import {fromJS } from 'immutable';
import {STATE_IS_TRANSMITTING, STATE_TRANSMISSION_STATUS} from "./main";

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    let deserializedState = JSON.parse(serializedState);
    return {
      main: fromJS(deserializedState.main).set(STATE_IS_TRANSMITTING, false).set(STATE_TRANSMISSION_STATUS, 'initial'),
      parent: fromJS(deserializedState.parent),
      children: fromJS(deserializedState.children)
    }
  }
  catch (err) {
    console.warn(`Could not Load State ${err}`);
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('state', serializedState);
  } catch (err) {
    console.error(`Could not Save State ${err}`);
  }
};



// WEBPACK FOOTER //
// ./src/localStorage.js